import { jsx as r } from "react/jsx-runtime";
const a = ({ text: c }) => /* @__PURE__ */ r("div", { className: "product-card-badge-club", children: /* @__PURE__ */ r("p", { className: "product-card-badge-club-text", children: c }) });
export {
  a as ProductCardBadgeClub
};
